import React from "react";
import { NavLink } from "react-router-dom";
import Dtr from "../../components/timesheet/Dtr";
import { useSidebarData } from "../../hooks/sidebarData";
import { useQuery } from "@tanstack/react-query";

const View = () => {
    const { setSidebarData } = useSidebarData();

    const uname = sessionStorage.getItem('uname') || ''; 

    const { data: role } = useQuery({
        queryKey: ['userrole']
    });

    const { data: manageddepartments } = useQuery({
        queryKey: ['managedDepartments', uname]
    });

    const { data: managedadjustments } = useQuery({
        queryKey: ['managedAdjustments', uname]
    });

    const breadcrumbs = [
        { name: 'DTR', path: '/dtr/my-dtr' },
        { name: 'Timesheets', path: '/dtr/timesheets' },
        {
            name: sessionStorage.getItem('timesheetChild'),
            path: `/dtr/timesheets/${sessionStorage.getItem('timesheetChildSlug')}`
        },
        ...((role === 'admin' || role === 'management') || manageddepartments?.length > 1 || managedadjustments?.length > 1
            ? [{
                name: sessionStorage.getItem('timesheetGrandchild'),
                path: `/dtr/timesheets/${sessionStorage.getItem('timesheetChildSlug')}/${sessionStorage.getItem('timesheetGrandchildSlug')}`
            }]
            : []
        ),
        ...((role === 'admin' || role === 'management') || manageddepartments?.length > 1 || managedadjustments?.length > 1
            ? [{
                name: sessionStorage.getItem('timesheetPayperiod'),
                path: `/dtr/timesheets/${sessionStorage.getItem('timesheetChildSlug')}/${sessionStorage.getItem('timesheetGrandchildSlug')}/${sessionStorage.getItem('timesheetPayperiodId')}`
            }]
            : [{
                name: sessionStorage.getItem('timesheetPayperiod'),
                path: `/dtr/timesheets/${sessionStorage.getItem('timesheetChildSlug')}/${sessionStorage.getItem('timesheetPayperiodId')}`
            }]
        ),
    ];

    const handleClearSidebarData = () => {
        setSidebarData('state', false);
        setSidebarData('key', '');
        setSidebarData('label', '');
        setSidebarData('data', []);
    }

    return (
        <div className="dtr">
            <div className="page-header">
                <div className='title'>
                    <h1>Timesheets</h1>
                    <ul className='breadcrumbs'>
                        {breadcrumbs.map((crumb, index) => (
                            <li key={index}>
                                <NavLink to={crumb.path} onClick={handleClearSidebarData}>
                                    {crumb.name || 'N/A'}
                                </NavLink>
                            </li>
                        ))}
                        <li>
                            <span>{sessionStorage.getItem('timesheetEmployee') || 'Employee'}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="content">
                <div className="files">
                    <Dtr />
                </div>
            </div>
        </div>
    );
}

export default View;